var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 53,
    viewBox: "0 0 46 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4143 8.71187V14.3928H41.4062C36.9442 14.3972 32.5648 13.1893 28.7359 10.8981L23.6678 7.83406C23.373 7.65577 23.0351 7.56152 22.6906 7.56152C22.3461 7.56152 22.0082 7.65577 21.7134 7.83406L16.6619 10.8816C12.832 13.1704 8.45325 14.3781 3.99156 14.3762H1.36325e-09V8.71187C-1.89895e-05 8.20957 0.198377 7.7276 0.552001 7.37087C0.905625 7.01415 1.38584 6.81155 1.88812 6.80718H4.00812C8.81245 6.80835 13.5258 5.49686 17.639 3.01437L22.7072 0L27.7587 3.03094C31.8747 5.50722 36.5862 6.81822 41.3897 6.82374H43.5262C44.0243 6.83226 44.4996 7.03392 44.8519 7.38619C45.2042 7.73845 45.4058 8.21377 45.4143 8.71187Z",
    fill: "#FF3811"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4062 18.2189C36.2589 18.2165 31.2092 16.8138 26.7981 14.1611L22.7072 11.6768L18.6162 14.1114C14.2091 16.7793 9.15977 18.199 4.00812 18.2189H0V23.1877C0.0116 28.9374 1.65928 34.565 4.75051 39.413C7.84174 44.261 12.2488 48.1292 17.4569 50.5655L22.7072 53.0002L27.9244 50.5655C33.1398 48.1356 37.5549 44.2699 40.6524 39.4211C43.75 34.5724 45.4018 28.9414 45.4143 23.1877V18.2189H41.4062ZM23.6678 34.7814C23.3161 35.1195 22.8472 35.3083 22.3594 35.3083C21.8715 35.3083 21.4026 35.1195 21.0509 34.7814L15.7509 29.4814L18.4175 26.8149L22.3925 30.7733L29.0175 24.1483L31.684 26.8149L23.6678 34.7814Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2b252ba77abf245731630d4397c12eaa.svg";
export { ForwardRef as ReactComponent };